import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { SelectComponent } from '../../../core/controls/select.component';
import { HelpIconComponent } from '../../../core/labels/help-icon.component';

@Component({
  selector: 'app-select-option',
  imports: [SelectComponent, HelpIconComponent],
  template: `
    <div class="tw-col-span-3 tw-flex" role="group" [attr.aria-labelledby]="labelId">
      <span class="label tw-grow tw-font-bold tw-pt-2" [id]="labelId">{{ label }}</span>
      @if (showList) {
        <app-select
          class="tw-w-[150px]"
          [options]="alerts.listItems"
          optionLabel="description"
          [optionValue]="null"
          [control]="listControl"
          label="Condition"
          [filter]="filter"
          [virtualScroll]="false"
          [showClear]="false"
          [showHeader]="showHeader"
        />
      }
      <app-select
        [options]="items"
        [style.width.px]="width"
        optionLabel="description"
        [optionValue]="optionValue"
        optionDisabled="disabled"
        [control]="control"
        [label]="selectLabel"
        [ariaLabelledBy]="labelId"
        [filter]="filter"
        [virtualScroll]="
          virtualScroll !== null ? virtualScroll : items?.length > 10
        "
        [showClear]="showClear"
        [multiple]="multiple"
        [multipleFilter]="filter"
        [chip]="true"
        [showHeader]="showHeader"
        [maxSelectedLabels]="maxSelectedLabels"
        [group]="group"
      />
      @if (helpText) {
        <div class="tw-flex tw-pt-2 tw-gap-2">
          <app-help-icon [helpText]="helpText" size="20px" />
        </div>
      }
    </div>
  `,
  styles: ``,
})
export class SelectOptionComponent implements OnInit {
  alerts = inject(AlertsService);

  protected labelId = 'select-option-' + Math.trunc(Math.random() * 100000);

  @Input()
  listControl: FormControl<string>;

  @Input()
  control: FormControl<any>;

  @Input()
  showClear = false;

  @Input()
  items: any[];

  @Input()
  optionValue = 'value';

  @Input()
  showList = false;

  @Input()
  virtualScroll: boolean = null;

  @Input()
  label: string;

  @Input()
  selectLabel = 'Values';

  @Input()
  multiple = false;

  @Input()
  filter = false;

  @Input()
  showHeader = false;

  @Input()
  maxSelectedLabels = 10;

  @Input()
  group = false;

  @Input()
  defaultValue: string;

  @Input()
  helpText: string;

  @Input()
  listControlRequired = false;

  @Input()
  width = 450;

  ngOnInit(): void {
    if (this.listControlRequired)
    {
      this.listControl.setValidators([Validators.required]);
    }
  }
}
